import React from 'react';
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface CreativeQuality {
  campaign_id: string;
  campaign_name: string;
  product_name: string;
  funnel_stage: string;
  creative_type: string;
  creative_url: string;
  hook: string;
  is_ugc: boolean;
  has_captions: boolean;
  video_length_sec: number;
  avg_engagement_rate: number;
  total_saves: number;
  total_comments: number;
  total_shares: number;
  video_views_3s: number;
  total_video_views: number;
  hook_retention_rate: number;
  avg_watch_time_sec: number;
  spend: number;
  impressions: number;
  avg_cpm: number;
  reach: number;
  creative_quality_score: number;
  creative_status: 'winner' | 'loser' | 'testing';
}

export function useCreativeQuality(productName: string | null) {
  return useQuery({
    queryKey: ['creative-quality', productName],
    queryFn: async () => {
      if (!productName) return [];

      const { data, error } = await supabase
        .from('v_creative_quality_score')
        .select('*')
        .eq('product_name', productName)
        .order('creative_quality_score', { ascending: false })
        .limit(20);

      if (error) throw error;
      return data as CreativeQuality[];
    },
    enabled: !!productName,
  });
}
